export default {
  个人信息: "个人信息",
  用户姓名: "用户姓名",
  工号: "工号",
  部门: "部门",
  岗位: "岗位",
  邮箱: "邮箱",
  帐号密码信息: "帐号密码信息",
  修改帐号密码: "修改帐号密码",
  获取验证码: "获取验证码",
  下一步: "下一步",
  邮箱号: "邮箱号",
  请输入邮箱: "请输入邮箱！",
  请输入有效的邮箱格式: "请输入有效的邮箱格式",
  验证码: "验证码",
  请输入验证码: "请输入验证码！",
  s后重试: "s后重试",
  密码修改成功: "密码修改成功，请使用新密码登录",
  邮箱验证失败: "邮箱验证失败",
};
